import SlideshowPlayer from "../components/SlideshowPlayer";
export default function PublicSlideshowPage() {
  return <SlideshowPlayer source="public" />;
}
